<script setup>
import PhoneBookMain from '@/components/phonebook/PhoneBookMain.vue'
</script>

<template>
  <phone-book-main />
</template>
